"use client";

type StaticImageLoaderProps = {
  src: string;
  width: number;
  quality?: number;
};

const exactOptimizedIcons = new Set([
  "/assets/corrected/landing/why-verified.webp",
  "/assets/corrected/landing/why-professional.webp",
  "/assets/corrected/landing/why-coordination.webp",
  "/assets/corrected/landing/why-personalized.webp",
  "/assets/corrected/landing/why-updates.webp",
  "/assets/corrected/nurse/stat-families.webp",
  "/assets/corrected/nurse/stat-nurses.webp",
  "/assets/corrected/nurse/stat-visits.webp",
  "/assets/corrected/nurse/stat-satisfaction.webp",
  "/assets/corrected/nurse/why-verified.webp",
  "/assets/corrected/nurse/why-professional.webp",
  "/assets/corrected/nurse/why-coordination.webp",
  "/assets/corrected/nurse/why-personalized.webp",
  "/assets/corrected/nurse/why-updates.webp",
]);

function variantPath(src: string, suffix: string) {
  return src.replace(/\.webp$/i, `${suffix}.webp`);
}

function withRequestedWidth(src: string, width: number) {
  return `${src}#cv-width=${width}`;
}

export default function staticImageLoader({ src, width }: StaticImageLoaderProps) {
  let candidate = src;

  if (exactOptimizedIcons.has(src)) {
    candidate = variantPath(src, "-optimized");
  } else if (src === "/assets/corrected/landing/hero-care-optimized.webp" && width <= 768) {
    candidate = variantPath(src, "-w512");
  } else if (src === "/assets/corrected/landing/why-center-optimized.webp" && width <= 768) {
    candidate = variantPath(src, "-w512");
  } else if (src === "/assets/corrected/landing/standards-care.webp" && width <= 640) {
    candidate = variantPath(src, "-w568");
  } else if (src === "/assets/corrected/landing/app-mockup.webp" && width <= 640) {
    candidate = variantPath(src, "-w512");
  } else if (src === "/assets/corrected/nurse/hero.webp" && width <= 360) {
    candidate = variantPath(src, "-w360");
  } else if (/^\/assets\/corrected\/nurse\/service-.+-560\.webp$/.test(src)) {
    candidate = width <= 256
      ? variantPath(src, "-w210")
      : width <= 360
        ? variantPath(src, "-w360")
        : width <= 512
          ? variantPath(src, "-w420")
          : src;
  } else if (/^\/assets\/corrected\/nurse\/promise-.+-160\.webp$/.test(src) && width <= 128) {
    candidate = variantPath(src, "-w80");
  } else if (/^\/assets\/corrected\/nurse\/step-.+-288\.webp$/.test(src) && width <= 192) {
    candidate = variantPath(src, "-w150");
  } else if (/^\/assets\/corrected\/nurse\/professional-.+-120\.webp$/.test(src) && width <= 96) {
    candidate = variantPath(src, "-w60");
  } else if (/^\/assets\/providerPage\/track-.+\.webp$/.test(src) && width <= 64) {
    candidate = variantPath(src, "-w64");
  } else if (/^\/assets\/providerPage\/workflow-.+\.webp$/.test(src) && width <= 128) {
    candidate = variantPath(src, "-w120");
  } else if (/^\/assets\/providerPage\/support-.+\.webp$/.test(src) && width <= 64) {
    candidate = variantPath(src, "-w50");
  } else if (src === "/assets/corrected/provider/hero-provider-optimized.webp" && width <= 768) {
    candidate = variantPath(src, "-w512");
  }

  return withRequestedWidth(candidate, width);
}
